module.exports = "data:application/octet-stream;base64,cHJlY2lzaW9uIGhpZ2hwIGZsb2F0OwoKdmFyeWluZyB2ZWMyIG91dFRleDsKdW5pZm9ybSBzYW1wbGVyMkQgWDsKdW5pZm9ybSBpbnQgcmVsdTsKCnZvaWQgbWFpbih2b2lkKSB7CiAgaWYgKHJlbHUgPT0gMSkgewogICAgZ2xfRnJhZ0NvbG9yID0gbWF4KHRleHR1cmUyRChYLCB2ZWMyKG91dFRleC54LCBvdXRUZXgueSkpLCAwLjApOwogIH0gZWxzZSB7CiAgICBnbF9GcmFnQ29sb3IgPSB0ZXh0dXJlMkQoWCwgdmVjMihvdXRUZXgueCwgb3V0VGV4LnkpKTsKICB9Cn0K"


//////////////////
// WEBPACK FOOTER
// ./~/keras-js/lib/ext/core/activation.glsl
// module id = TaZx
// module chunks = 1